<div
  class="group mt-3 flex w-full items-start gap-2 rounded-xl px-2 py-3 transition-all duration-200 hover:shadow-sm bg-muted min-h-20 relative"
  [ngClass]="{
    'cursor-pointer': isTextClamped() || expanded(),
  }"
>
  <!-- importance icon -->
  <i [notificationsIcon]="notification().importanceLevel"></i>

  <div class="flex min-w-0 flex-1 flex-col items-start">
    <!-- title -->
    <p
      #msgElement
      class="notification-msg w-full text-start text-base font-medium leading-7 text-text"
      [ngClass]="{ expanded: expanded() }"
      tabindex="-1"
      (click)="toggleExpanded()"
      (keydown.enter)="toggleExpanded()"
    >
      <span>{{ notification().title }}</span>

      <!-- buy plan app-btn  -->
      @if (
        notification().notificationTypes ==
        NotificationTypes.OrganizationExpiration
      ) {
        <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
        <a
          class="group mt-2 flex h-[30px] w-[140px] items-center justify-center gap-1 rounded-md bg-surface-2 text-[12px]"
          style="border-color: unset !important"
          tabindex="-1"
          (click)="openTab(pageNames.buyPlanPackage)"
          (keydown.event)="openTab(pageNames.buyPlanPackage)"
        >
          <i
            class="mdi mdi-18px mdi-shopping text-accent-foreground group-hover:text-accent-hover"
          ></i>
          <span class="text-accent-foreground group-hover:text-accent-hover">
            {{ "common.buyPlan" | translate }}</span
          >
        </a>
      }
    </p>

    <!-- meta -->
    <div
      class="mt-2 flex w-full items-center justify-between gap-2 text-sm text-muted-foreground"
    >
      <div class="flex items-center gap-1">
        <span>
          {{ notification().created | convertDateToTime: "fa-IR" }}
        </span>
        @if (
          (notification().created
            | dateTimeConvertor: appStateService.currentAppLang()) != "-"
        ) {
          <span class="mx-1 dir-ltr text-sm">
            (<span>{{
              (
                notification().created
                | dateTimeConvertor: appStateService.currentAppLang()
              )?.split("-")[1]
            }}</span
            >)
          </span>
        }
      </div>
    </div>
  </div>

  <!-- dismiss seen -->
  @if (!notification().isSeen) {
    @if (loading()) {
      <span class="loading loading-spinner loading-xs shrink-0"></span>
    } @else {
      <i
        class="mdi mdi-close cursor-pointer text-muted-foreground hover:text-danger opacity-70 mdi-16px shrink-0"
        tabindex="-1"
        (click)="notificationSeenApi(notification().notificationId)"
        (keydown.event)="notificationSeenApi(notification().notificationId)"
      ></i>
    }
  }

  @if (isTextClamped() || expanded()) {
    <i
      class="mdi mdi-18px cursor-pointer text-muted-foreground absolute bottom-2 left-2"
      [ngClass]="expanded() ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      tabindex="-1"
      (click)="toggleExpanded()"
      (keydown.enter)="toggleExpanded()"
    ></i>
  }
</div>
